import { render, staticRenderFns } from "./stock-inquiry.vue?vue&type=template&id=1b886ee9&"
import script from "./stock-inquiry.vue?vue&type=script&lang=js&"
export * from "./stock-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports